var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#347af0;stroke:#707070;opacity:0;}.b{fill:#438afe;stroke:#438afe;stroke-width:0.3px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.7,48.715a.451.451,0,0,0-.451.451v4a1.353,1.353,0,0,1-1.352,1.352H2.253A1.353,1.353,0,0,1,.9,53.166V41.425a1.353,1.353,0,0,1,1.352-1.352h4a.451.451,0,0,0,0-.9h-4A2.255,2.255,0,0,0,0,41.425V53.166a2.255,2.255,0,0,0,2.253,2.253H14.895a2.255,2.255,0,0,0,2.253-2.253v-4a.451.451,0,0,0-.451-.451Zm0,0",
    transform: "translate(0 -37.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.285.855a2.028,2.028,0,0,0-2.867,0l-8.038,8.038a.45.45,0,0,0-.116.2l-1.057,3.816a.45.45,0,0,0,.554.555l3.816-1.057a.45.45,0,0,0,.2-.116l8.038-8.038a2.03,2.03,0,0,0,0-2.867Zm-9.924,8.331,6.579-6.579,2.122,2.122-6.579,6.579Zm-.424.85,1.7,1.7-2.345.65Zm10.239-6.423-.478.478L117.577,1.97l.478-.478a1.126,1.126,0,0,1,1.593,0l.529.529A1.128,1.128,0,0,1,120.176,3.614Zm0,0",
    transform: "translate(-103.316 -0.261)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.49a7563efac0943ca74fb9e74420edc2.svg";
export { ForwardRef as ReactComponent };